import { useMsal } from '@azure/msal-react';
import React, { useState, useReducer, useEffect } from 'react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from '..';

export default function useGraph<T>(query: string) {
  const [data, setData] = useState<T>();

  useEffect(() => {
    msalInstance.acquireTokenSilent({ scopes: ['User.Read', 'Mail.Read'] }).then(res => {
      if (res.accessToken) {
        var headers = new Headers();
        var bearer = 'Bearer ' + res.accessToken;
        headers.append('Authorization', bearer);

        var options = {
          method: 'GET',
          headers: headers,
        };
        var graphEndpoint = query || 'https://graph.microsoft.com/v1.0/me';

        fetch(graphEndpoint, options)
          .then(resp => {
            return resp.json();
          })
          .then(resp => {
            //do something with response
            //console.log('resp',resp);
            setData(resp);
            //return resp;
          });
      }
    });
  }, []);

  return data;

  /* const [data,setData] = useState();
    const { instance, accounts, inProgress } = useMsal();
    let accessToken = null;
    useEffect(() => {
        if (inProgress === "none" && accounts.length > 0) {
            // Retrieve an access token
            accessToken = instance.acquireTokenSilent({
                account: accounts[0],
                scopes: ["User.Read"]
            }).then(response => {
                if (response.accessToken) {
                    return response.accessToken;
                }
                return null;
            });
        }
    }, [inProgress, accounts, instance]);
    
    if (inProgress === "login") {
        // Render loading component
    } else if (accessToken) {
        // Call your api and render component

        var headers = new Headers();
        var bearer = "Bearer " + accessToken;
        headers.append("Authorization", bearer);

        var options = {
            method: "GET",
            headers: headers
        };
        var graphEndpoint = query || "https://graph.microsoft.com/v1.0/me";

    fetch(graphEndpoint, options)
            .then(resp => {
            //do something with response
            console.log('resp',resp);
            return resp;
            });
        //tData(results.json());
            return [data];
    }
    
*/
}
